const _ = require("lodash");

// Versi baru: support single & multi detail
// - Jika ada details: exclude period, standMeter, qty dari body
//   - details.length > 1 (multi): caption detail diberi index (" 1", " 2", dst), dueAmount di-skip
//   - details.length === 1 (single): caption tanpa index, dueAmount di-skip
// - Jika tidak ada details: semua key tampil
module.exports = (obj, preview = false) => {
  let detailIdx = -1;
  const isMultiDetail = obj.details && obj.details.length > 1;
  const excludeKeys = obj.details ? ["period", "standMeter", "qty"] : [];
  const arr = Object.keys(obj)
    .filter((key) => !excludeKeys.includes(key))
    .map((key, idx) => {
      if (key === "info") return [obj[key]?.value];
      else if (key === "details") {
        detailIdx = idx;
        const details = obj[key];

        return details.map((item, index) => {
          return Object.keys(item)
            .filter((key1) => preview || key1 !== "dueAmount")
            .filter((key1) => item[key1]?.caption)
            .map((key1) => {
              const caption = isMultiDetail
                ? item[key1].caption + " " + (index + 1)
                : item[key1].caption;
              return [caption, item[key1]?.value];
            });
        });
      } else {
        if (!obj[key]?.caption) return null;
        return [obj[key].caption, obj[key]?.value];
      }
    })
    .filter(Boolean);
  if (obj.details) return flatten(arr, detailIdx);
  else return arr;
};

// Versi original: semua key tampil tanpa filter,
// details di-map dengan index (" 1", " 2", dst)
module.exports.legacy = (obj) => {
  let detailIdx = -1;
  const arr = Object.keys(obj)
    .map((key, idx) => {
      if (key === "info") return [obj[key]?.value];
      else if (key === "details") {
        detailIdx = idx;
        const details = obj[key];
        return details.map((item, index) => {
          return Object.keys(item)
            .filter((key1) => item[key1]?.caption)
            .map((key1) => {
              return [
                item[key1].caption + " " + (index + 1),
                item[key1]?.value,
              ];
            });
        });
      } else {
        if (!obj[key]?.caption) return null;
        return [obj[key].caption, obj[key]?.value];
      }
    })
    .filter(Boolean);
  if (obj.details) return flatten(arr, detailIdx);
  else return arr;
};

// Skip object details sepenuhnya, hanya tampilkan key body
module.exports.withoutDetails = (obj) => {
  return Object.keys(obj)
    .filter((key) => key !== "details")
    .map((key) => {
      if (key === "info") return [obj[key]?.value];
      if (!obj[key]?.caption) return null;
      return [obj[key].caption, obj[key]?.value];
    })
    .filter(Boolean);
};

function flatten(arr, detailIdx) {
  const detailArr = _.flattenDepth(arr[detailIdx], 1);
  detailArr.map((item, index) => {
    if (index === 0) {
      arr.splice(detailIdx, 1, item);
    } else arr.splice(detailIdx + index, 0, item);
  });
  return arr;
}
